const moment = require('moment');
const { TIMEOFF, TIMEOFF_STATUS } = require('../helpers/constants');

export default class TimeoffFilter {
  constructor(startDate) {
    this.startDate = startDate;
    this.startOfYear = moment(startDate).startOf('year').format('YYYY-MM-DD');
    this.endOfYear = moment(startDate).endOf('year').format('YYYY-MM-DD');
    this.startOfTimeoffMonth = moment(startDate).startOf('month').format('YYYY-MM-DD');
    this.endOfTimeoffMonth = moment(startDate).endOf('month').format('YYYY-MM-DD');
  }

  isValidTimeoff(timeoff) {
    // Individually calculate wfh monthly balance and used.
    if (timeoff.type === TIMEOFF.WFH.type) {
      if (
        (timeoff.status === TIMEOFF_STATUS.APPROVED || timeoff.status === TIMEOFF_STATUS.PENDING) &&
        (timeoff.startDate > this.startOfTimeoffMonth && timeoff.endDate < this.endOfTimeoffMonth)) {
        return true;
      } else {
        return false;
      }
    }

    // skip process, rejected, or after startDate of current
    if (
      timeoff.processed ||
      timeoff.status === TIMEOFF_STATUS.REJECTED ||
      timeoff.status === TIMEOFF_STATUS.CANCELLED ||
      timeoff.endDate < this.startOfYear ||
      timeoff.startDate > this.endOfYear ||
      (this.startDate && timeoff.startDate > this.startDate)
    ) {
      return false;
    }

    return true;

  }

  validDaysWithinFilterYear(timeoff) {
    if (
      (timeoff.status === TIMEOFF_STATUS.APPROVED || timeoff.status === TIMEOFF_STATUS.PENDING) &&
      (timeoff.startDate >= this.startOfYear && timeoff.startDate <= this.endOfYear)
    ) {
      const localDaysNextYear = timeoff.daysNextYear || 0;
      return timeoff.days - localDaysNextYear;
    }

    return 0;
  }

}



// WEBPACK FOOTER //
// ./src/class/TimeoffFilter.js